// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"8222f3a4","213":"10eaf575","337":"91e3a418","455":"ac64c6e8","512":"d7f1569f","585":"4f472d5f","735":"f0a49cef","836":"8bc66baa","840":"b4181645","857":"4439e47e","885":"fc9c31ce","890":"733e5635"}[chunkId] + ".chunk.js";
};